import {
  Component,
  computed,
  input,
  output,
} from '@angular/core'
import { PageHeaderComponent } from '../page-header/page-header.component'
import { ActiveFilterListComponent } from '../table/filters/active-filter-list/active-filter-list.component'
import { DashboardFilter } from './dashboard-filter.component'
import { CollapsibleSectionComponent } from '../collapsible-section/collapsible-section'
import { DashboardData } from './dashboard.component'

@Component({
  selector: 'app-dashboard-header',
  imports: [
    PageHeaderComponent,
    ActiveFilterListComponent,
    DashboardFilter,
    CollapsibleSectionComponent,
  ],
  template: `
    <div app-page-header [header]="data().config.display"></div>
    <app-collapsible-section [collapseDisabled]="!data().url">
      <app-active-filter-list
          [filterGroup]="data().config.name"
          [filterName]="pageFilters()"
      />
      <app-dashboard-filter [dashboard]="data().config"/>
      @if (hasConfigurableParams()) {
        <div class='button-bar'>
          @if (data().requirementsMet) {
            <button
                class='btn btn-sm'
                [class.btn-outline-primary]="reloadEnabled()"
                [class.btn-outline-secondary]="!reloadEnabled()"
                [disabled]="!reloadEnabled()"
                (click)="onReload.emit()"
            >
              Reload
            </button>
          } @else {
            <div class='requirements-message'>
              {{ data().config.requirements.message ?? 'At least one more filter needed' }}
            </div>
          }
        </div>          
      }
    </app-collapsible-section>
  `,
  styles: `
    .button-bar {
      min-width: 1rem;
      min-height: 48px;
      padding-top: 1rem;
      
      .requirements-message {
        padding-top: 0.5rem;
        font-weight: bold;
        color: var(--active-blue);
      }
    }
  `,
})
export class DashboardHeaderComponent {
  readonly data = input.required<DashboardData>()

  readonly onReload = output()

  protected hasConfigurableParams = computed((): boolean =>
    this.data().config.params.some(p => !p.constant),
  )

  protected readonly pageFilters = computed((): readonly string[] =>
    this.data().config.params.map(_ => _.widget),
  )

  protected readonly reloadEnabled = computed((): boolean => {
    const { requirementsMet, filterModified } = this.data()
    return requirementsMet && filterModified
  })
}
